"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SvgQuestionCircle = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Svg = _interopRequireDefault(require("./Svg"));

var SvgQuestionCircle = function SvgQuestionCircle(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["size", "title", "desc", "titleId", "descId"]);
  return _react["default"].createElement(_Svg["default"], (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: "currentcolor"
  }, props), !!title && _react["default"].createElement("title", {
    id: titleId
  }, title), !!desc && _react["default"].createElement("desc", {
    id: descId
  }, desc), _react["default"].createElement("path", {
    d: "M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm0 19.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3.69-8.73c-.72.86-2.04 1.6-2.53 2.35-.29.44-.29.95-.28 1.44h-1.79c0-.55-.04-1.36.37-2.1.24-.44.67-.9 1.27-1.37 1.2-.95 1.71-1.44 1.71-2.46 0-1.13-.84-1.58-1.97-1.59-.75 0-1.57.11-3.04.84l-.77-1.6a8.01 8.01 0 013.96-1.03c1.19 0 2.13.29 2.83.87s1.05 1.39 1.05 2.42c0 .86-.23 1.55-.81 2.23z"
  }));
};

exports.SvgQuestionCircle = SvgQuestionCircle;
SvgQuestionCircle.isIcon = true;
SvgQuestionCircle.defaultProps = {
  size: 24,
  'aria-hidden': 'true',
  focusable: 'false'
};
var _default = SvgQuestionCircle;
exports["default"] = _default;